import { TFileItem, TFileSubfoldersItem } from '@/data/types';

export interface FilesState {
  items: TFileItem[];
  subfolders: TFileSubfoldersItem[];
  currentFile: TFileItem | null;
}

export const DefaultFilesState: FilesState = {
  items: [],
  subfolders: [],
  currentFile: null,
};
